export default __webpack_public_path__ + "static/media/ic-teachers.f7abf9f3.svg";